import React, { FC, MouseEvent } from "react";
import Wrp from "../../components/layout/Wrp/Wrp";
import Table from "../../components/dataDisplay/table/Table";
import { DATA_INDEX_EMPLOYEES } from "../../utl/constants/tables";
import { EmployeesColumns } from "./models/EmployeesColumns";
import { PagePagination } from "../../components/dataDisplay/table/models/PagePagination";

interface Props {
    data: Array<EmployeesColumns>; 
    page: number;
    pages: PagePagination[];
    handleLeftButtonPagination: () => void;
    handleRightButtonPagination: () => void;
    handleClickRow: (item: any, event: MouseEvent<HTMLTableRowElement>) => void;
}

const Employees: FC<Props> = ({data, page, pages, handleLeftButtonPagination, handleRightButtonPagination, handleClickRow}) => {
    return (
        <Wrp maxWidth={955}>
            <Table 
                handleClickRow={handleClickRow}
                data={data} 
                columns={DATA_INDEX_EMPLOYEES} 
                paginated={true}
                page={page}
                pages={pages}
                handleLeftButtonPagination={handleLeftButtonPagination}
                handleRightButtonPagination={handleRightButtonPagination}
            />
        </Wrp>
    );
}

export default Employees;